import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { components, constants, DataFlattener, useTranslation, useServices } from 'cng-web-lib'
import ManifestEditPage from './ManifestEditForm'
import CargoAttachTable from './cargo/CargoAttachTable'
import StatusNotificationListPage from './StatusNotificationListPage'
import { Box, Card, useTheme } from '@material-ui/core'
import Stepper from '../../../components/aciacehighway/Stepper'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import ChargeTypeDialog from '../../common/ChargeTypeDialog'
import pathMap from '../../../paths/pathMap'
import Namespace from '../../../constants/locale/Namespace'
import ManifestKeys from '../../../constants/locale/key/AciHighwayManifest'
import AciHighwayManifestApiUrls from '../../../apiUrls/AciHighwayManifestApiUrls'
import { getStatusMetadata } from '../../../common/NACommon'
import axios from 'axios'
import ViewLogsHistory from './ViewLogsHistory'
import { FileForUserGetUserDetails, GetLoggedInUserPartyName } from 'src/common/FileForUserCommon'
import moment from 'moment-timezone'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  table: { useFetchCodeMaintenanceLookup },
} = components

const { filter: { EQUAL } } = constants

function EditPage(props) {
  const { history, loading, location, onSetLoading, showNotification } = props
  const { id } = useParams()
  const { state } = location
  const manifestData = useRef(state?.manifestData || null)
  const [step, setStep] = useState((state?.step ? state.step : 1) - 1)
  const [manifestStatus, setManifestStatus] = useState(state?.status ? state.status : null)
  const [stepIconColor, setStepIconColor] = useState({})
  const [completed, setCompleted] = useState({})
  const theme = useTheme()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const { createRecord } = useServices()

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()   

  const [chargeTypes, setChargeTypes] = useState([])
  const [submitDialog, setSubmitDialog] = useState({ open: false, items: [] })

  const [isSuperParty, setSuperParty] = useState(false);

  useEffect(() => {
    Promise.all([
      // Charge type
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'BILLING_CHARGE_TYPE' }],
        undefined,
        'code'
      ),
      // Super party
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'BILLING_SUPER_PARTY' }],
        undefined, 'code'
      )
    ]).then(
      ([billingChargeTypes, billingSuperParty]) => {
        compileChargeTypes(billingChargeTypes)

        Object.keys(billingSuperParty).forEach(e => {
          if (e == GetLoggedInUserPartyName()) {
            setSuperParty(true);
          }
        })
      }
    )
  }, [])

  function compileChargeTypes(billingChargeTypes) {
    var jsonArray = [];
    if (billingChargeTypes) {
      Object.entries(billingChargeTypes).forEach((e) => {
        var jsonObject = { code: e[0], desc: e[1] }
        jsonArray.push(jsonObject)
      })
    }
    setChargeTypes(jsonArray)
  }

  useEffect(() => {
    if (manifestStatus) {
      if (manifestStatus !== '1005') {
        setCompleted({ 0: true })
      }

      if (manifestStatus === '1001') {
        const rejectedColor = getStatusMetadata(manifestStatus)

        setStepIconColor({ 0: rejectedColor })
      }
    }
  }, [manifestStatus])

  function preSubmit() {
    const values = { ...manifestData.current, id }

    if (isSuperParty) {
      setSubmitDialog({ open: true, items: values })
    } else {
      values.chargeAs = 'REGULAR'
      manifestData.current = values
      handleSubmitManifest()
    }
  }

  function handleSubmitManifest() {
    onSetLoading(true)

    const values = { ...manifestData.current, id }
    values.expArrivalDate = values.expArrivalDate + ' ' + values.expArrivalTime

    const instance = axios.create({
      withCredentials: false,
      headers: {
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      }
    })

    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      values.fileForUserId = fileForUserDetails.fileForUserId;
      values.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      values.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }

    instance
      .post(AciHighwayManifestApiUrls.SUBMIT, DataFlattener.unflatten(values))
      .then(
        (result) => {
          var returnData = result.data
          var errorMessages = returnData.errorMessages
          if (
            result.status == 200 &&
            returnData != null &&
            errorMessages == null
          ) {
            showNotification('success', aciHighwayManifestTranslationText.submitSuccessMsg)
            history.push(pathMap.ACIHWY_MANIFEST_LIST_VIEW)
          } else {
            showNotification('error', errorMessages)
          }
        },
        (error) => {
          console.log(error)
        }
      )
      .finally(() => {
        onSetLoading(false)
      })
  }

  function handleCreateACEManifest() {
    onSetLoading(true)

    const values = { ...manifestData.current, id }
    values.expArrivalDate = values.expArrivalDate + ' ' + values.expArrivalTime

    const instance = axios.create({
      withCredentials: false,
      headers: {
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      }
    })

    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      values.fileForUserId = fileForUserDetails.fileForUserId;
      values.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
      values.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
    }

    console.log("values: " + JSON.stringify(values));
    instance
      .post(AciHighwayManifestApiUrls.CREATE_ACE_MANIFEST, DataFlattener.unflatten(values))
      .then(
        (result) => {
          var returnData = result.data
          var errorMessages = returnData.errorMessages
          if (
            result.status == 200 &&
            returnData != null &&
            errorMessages == null
          ) {
            returnData.arrivalTime = moment(returnData.arrivalDate).tz("Canada/Eastern").format('HH:mm');
            returnData.arrivalDate = moment(returnData.arrivalDate).tz("Canada/Eastern").format('YYYY-MM-DD');
            console.log("returnData: " + JSON.stringify(returnData));
            history.push(pathMap.ACE_HIGHWAY_MANIFEST_ADD_VIEW, returnData)
          } else {
            showNotification('error', errorMessages)
          }
        },
        (error) => {
          console.log(error)
        }
      )
      .finally(() => {
        onSetLoading(false)
      })
  }

  function renderContent(step) {
    switch (step) {
      case 0:
        return (
          <ManifestEditPage
            id={id}
            manifestData={manifestData}
            onChangeStep={(step) => setStep(step)}
            onSetLoading={onSetLoading}
            onSetManifestStatus={(status) => setManifestStatus(status)}
            onSubmitManifest={preSubmit}
            showNotification={showNotification}
            step={step}
            onCreateACEManifest={handleCreateACEManifest}
          />
        )
      case 1:
        return (
          <CargoAttachTable
            history={history}
            showNotification={showNotification}
            manifestId={id}
            firstExpectedPortValue={manifestData.current?.firstExpectedPort}
            expectedArrivalDateTimeValue={manifestData.current?.expArrivalDate}
            expectedArrivalTimeZoneValue={manifestData.current?.timeZone}
            tripNoValue={manifestData.current?.tripNum}
            onChangeStep={(step) => setStep(step)}
            step={step}
            loading={loading}
            onSetLoading={onSetLoading}
            manifestCarrierCode={manifestData.current?.carrierCode}
          />
        )
      case 2:
        return (
          <StatusNotificationListPage
            history={history}
            showNotification={showNotification}
            manifestId={id}
            manifestData={manifestData}
            onSetLoading={onSetLoading}
            onSubmitManifest={handleSubmitManifest}
            onChangeStep={(step) => setStep(step)}
            step={step}
          />
        )
      case 3:
        return (
          <ViewLogsHistory
            manifestId={id}
            history={history}
            onChangeStep={(step) => setStep(step)}
            onSubmitManifest={handleSubmitManifest}
            step={step}
            tripNo={manifestData.current?.tripNum}
          />
        )
    }
  }

  return (
    <>
      <Card>
        <Stepper
          steps={!manifestStatus || manifestStatus === '1005' ? 
            [aciHighwayManifestTranslationText.createTripStep, aciHighwayManifestTranslationText.addCargosStep, aciHighwayManifestTranslationText.setStatusNotificationStep] : 
            [aciHighwayManifestTranslationText.createTripStep, aciHighwayManifestTranslationText.addCargosStep, aciHighwayManifestTranslationText.setStatusNotificationStep, aciHighwayManifestTranslationText.viewLogsAndHistoryStep]}
          activeStep={step}
          completed={completed}
          onSetActiveStep={(step) => setStep(step)}
          stepIconColor={stepIconColor}
        />
        <Box padding={2}>
          {renderContent(step)}
        </Box>
      </Card>
      <ChargeTypeDialog
        chargeTypes={chargeTypes}
        onClose={() => setSubmitDialog({ open: false, items: [] })}
        onSubmit={(data) => {
          manifestData.current = data
          handleSubmitManifest()
        }}
        open={submitDialog.open}
        items={submitDialog.items}
      />
    </>
  )
}

export default withFormState(EditPage)
